<div *transloco="let t; read: 'lex-xi-action-button-bar'" class="lex-xi-action-buttons__wrapper">
  <xi-default-button
    buttonSize="large"
    [text]="t('cancel')"
    fill="text"
    [disabled]="!!cancelDisabled()"
    (onClick)="cancel()"
  ></xi-default-button>

  <xi-default-button
    buttonSize="large"
    [text]="t('save')"
    [disabled]="!!saveDisabled()"
    (onClick)="save()"
  ></xi-default-button>
</div>
